<template>
    <div id="loan-data">
        <div class="vx-row p-2 mt-2 mb-2">
            <div class="vx-col w-full">
                <h3>Expediente de proyecto</h3>
                <p>
                    Aquí encontrarás de manera rápida toda la información relacionada al proyecto.
                </p>
                <vs-divider></vs-divider>
            </div>
            <div class="vx-col sm:w-full md:w-2/3 lg:w-2/3 p-0">
                <!-- Detalle de proyecto -->
                <div id="project-detail" class="mb-2">
                    <h6 class="success bold">CRÉDITO / SOLICITANTE</h6>
                    <vs-list>
                        <vs-list-item title="PID">{{ source.id }}</vs-list-item>
                        <vs-list-item title="Alias">{{ source.alias }}</vs-list-item>
                        <vs-list-item title="Estado">{{ source.status_named }}</vs-list-item>
                        <vs-list-item title="Tipo de persona">{{ translatePersonalType(user.person_type) }}</vs-list-item>
                        <vs-list-item title="Tipo de crédito">{{ translateCrowdfundingLoanType(source.finance.crowdfunding_loan_type) }}</vs-list-item>
                        <vs-list-item title="Producto financiero">{{ translateLoanType(source.finance.loan_type) }}</vs-list-item>
                        <vs-list-item title="Monto máximo permitido">{{ costFormat(applicant.max_loan_amount_allowed_mxn) }}</vs-list-item>
                    </vs-list>
                </div>
                <!-- Proveedor de proyecto -->
                <div v-if="supplier" id="supplier-detail" class="mb-2">
                    <h6 class="success bold">PROVEEDOR</h6>
                    <vs-list>
                        <vs-list-item title="SID">{{ supplier.id }}</vs-list-item>
                        <vs-list-item title="Nombre comercial">{{ supplier.tradename }}</vs-list-item>
                        <template v-if="supplier_agent != null">
                            <vs-list-item title="Agente">{{ supplier_agent.name }}</vs-list-item>
                            <vs-list-item title="Tel.">{{ supplier_agent.phone.country_calling_code }} {{ phoneFormat(supplier_agent.phone.phone) }}</vs-list-item>
                            <vs-list-item title="Email">{{ supplier_agent.user.email }}</vs-list-item>
                        </template>
                    </vs-list>
                </div>
                <!-- Solicitante de proyecto -->
                <div id="applicant-detail">
                    <h6 class="success bold">SOLICITANTE</h6>
                    <vs-list>
                        <vs-list-item title="CID">{{ applicant.id }}</vs-list-item>
                        <template v-if="isMoral">

                        </template>
                        <template v-else>
                            <vs-list-item title="Nombres">{{ personal.first_name }} {{ personal.second_name }}</vs-list-item>
                            <vs-list-item title="Apellido paterno">{{ personal.last_name_1 }}</vs-list-item>
                            <vs-list-item title="Apellido materno">{{ personal.last_name_2 }}</vs-list-item>
                            <vs-list-item title="Onboarding">{{ applicant.onboarding_step|| "--" }}</vs-list-item>
                            <vs-list-item title="CURP">{{ personal.curp||"--" }}</vs-list-item>
                            <vs-list-item title="RFC">{{ personal.rfc||"--" }}</vs-list-item>
                            <vs-list-item title="Fecha de nacimiento">{{ personal.birth_date }}</vs-list-item>
                            <vs-list-item title="País de nacimiento">{{ personal.origin_country }}</vs-list-item>
                            <vs-list-item title="Nacionalidad">{{ personal.citizenship }}</vs-list-item>
                            <vs-list-item title="Tel.">{{ personal.country_calling_code||"" }} {{ phoneFormat(personal.new_phone||"") }}</vs-list-item>
                            <vs-list-item title="Email">{{ user.email }}</vs-list-item>
                            <vs-list-item title="Verificación de identidad">
                                <vs-button v-if="personal.identity_verification_dashboard_url != null" target color="dark" radius icon-pack="feather" icon="icon-user" :href="$sanitizeUrl(personal.identity_verification_dashboard_url)"></vs-button>
                                <label v-else>No realizada</label>
                            </vs-list-item>

                        </template>
                    </vs-list>
                </div>
                <vs-divider></vs-divider>
            </div>
            <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3 p-0">
                <credit-events-log ref="creditEvents" :projectId="source.id" />
            </div>
        </div>
        {{ source }}
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper";
import projectStatusHelper from "@mixins/projectStatusesHelper.js"
import CreditEventsLog from "@components/projectsv2/CreditEventsLog";

export default {
    name: "LoanData",
    mixins: [formatHelper, projectStatusHelper],
    data: () => ({
        drawer: true,
        drawerRight: true,
        right: null,
        left: null
    }),
    props: {
        source: Object
    },
    components: {
        CreditEventsLog
    },
    computed:  {
        isMoral() {
            return this.source.client.user.person_type == 0;
        },
        user() {
            return this.source.client.user;
        },
        supplier() {
            return this.source.supplier;
        },
        supplier_agent() {
            return this.source.agent;
        },
        applicant() {
            return this.source.client;
        },
        finance() {
            return this.source.finance;
        },
        personal() {
            return this.source.client.user.personal;
        },
        business() {
            return this.source.client.user.personal;
        },
        applicantName() {
            if(this.isMoral) {
                return this.business.name
            }
        }
    },
    methods() {

    }
}
</script>